<template>
  <div>
    <!-- AI HISTORY MODAL -->
    <div class="text-center">
      <v-dialog 
        v-model="ai_history"
        max-width="950px"
        style='z-index: 2;'
      >
        <v-row justify="center">
          <v-card :style="'border-top: 5px solid ' + modalColor" min-width="500px">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-table
                fixed-header
                fixed-footer
                height="80vh"
              >
                <thead>
                  <tr>
                    <th>
                      <v-card-title style="width: 100%;">
                        <v-toolbar class="bg-white">
                          <v-icon
                            :style="'float: left; color: #fff; background-color: ' + modalColor"
                            class="float-left mr-2"
                            @click="store.setAIHistory(false)"
                            >mdi-chevron-left</v-icon
                          >
                          <v-toolbar-title 
                            class="ml-n1"
                            :color="modalColor"
                          >
                            Summary
                          </v-toolbar-title>
                          <v-icon
                            :color="modalColor"
                            class="float-right"
                            @click="$emit('add_note', item)"
                            >mdi-cached</v-icon
                          >
                        </v-toolbar>
                      </v-card-title>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <v-card-text style="width: 100%;">
                        <v-row>
                          <v-col cols="12" md="12" sm="12">
                            <v-toolbar color="rgb(255, 255, 255)">
                              <span class="text-ellipsis font-weight-bolder" :style="'color: ' + modalColor">
                                {{ item.itemName }}
                              </span>
                            </v-toolbar>
                            
                            <v-card
                              class="mx-auto elevation-0"
                            >
                              <v-table height="100vh">
                                <tbody>
                                  <!-- Welcome message bubble (always first, floats right like an answer) -->
                                  <tr>
                                    <td>
                                      <div class="d-flex justify-end align-center mb-6">
                                        <v-icon color="deep-purple accent-4" class="mr-2">mdi-robot</v-icon>
                                        <div class="bubble ai-bubble">
                                          <strong>Q:</strong> Welcome to eBoard AI, how may I assist you today?
                                          <div class="meta text-right">
                                            eBoard AI • {{ formatDateAndTime(notes.length > 0 ? notes[0].timestamp : Math.floor(Date.now() / 1000)) }}
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                  <!-- Conversation bubbles -->
                                  <tr v-for="(note, index) in notes" :key="index">
                                    <td>
                                      <!-- Question (User, right) -->
                                      <div class="d-flex justify-end align-center mb-2">
                                        <div class="bubble user-bubble">
                                          <strong>Q:</strong> {{ note.question }}
                                          <div class="meta text-right" v-if="note.userName">{{ note.userName ?? note.userId }} • {{ formatDateAndTime(note.timestamp) }}</div>
                                          <div class="meta text-right" v-else>{{ formatDateAndTime(note.timestamp) }}</div>
                                        </div>
                                        <v-icon color="primary" class="ml-2">mdi-account</v-icon>
                                      </div>
                                      <!-- Answer (AI, left) -->
                                      <div class="d-flex justify-start align-center mb-6">
                                        <v-icon color="deep-purple accent-4" class="mr-2">mdi-robot</v-icon>
                                        <div class="bubble ai-bubble">
                                          <strong>A:</strong> <span v-html="note.description"></span>
                                          <div class="meta">eBoard AI • {{ formatDateAndTime(note.timestamp) }}</div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="bg-white">
                      <v-textarea
                        class="mt-4"
                        label="Type your notes here"
                        rows="1"
                        variant="outlined"
                        v-model="comment"
                        :rules="rules.textRules"
                      >
                        <template v-slot:append>
                          <v-btn 
                            block
                            :color="modalColor"
                            class="text-white mt-n2"
                            @click="addDocumentNotes"
                            :loading="store.getLoading"
                          >
                            Send
                          </v-btn>
                        </template>
                      </v-textarea>
                    </td>
                  </tr>
                </tfoot>
              </v-table>
            </v-form>
          </v-card>
        </v-row>
      </v-dialog>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
import UserData from "../repository/UserData";
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";

export default {
  name: "ItemAIHistory",
  props: {
    notes: {
      type: Array,
      default: () => [],
    },

    modalColor: {
      type: String,
      default: "rgb(86, 182, 229)",
    },

    item: {
      type: Object,
      default: () => ({}),
    },

    currentAgenda: {
      type: Object,
      default: () => ({}),
    },

    currentAgendaDocument: {
      type: Object,
      default: () => ({}),
    },

    moduleCode: {
      type: String,
      default: "RSC",
    },
  },

  data: () => ({
    valid: false,
    comment: "",
    reply: "",
    show: false,
    current_comment: "",
    reply_comment: {},
    opened: [],
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
  }),

  computed: {
    current_agenda() {
      return this.store.getCurrentAgenda;
    },

    current_agenda_document() {
      return this.store.getCurrentAgendaDocument;
    },
    
    user() {
      return this.auth.getLoggedInUser;
    },

    ai_history() {
      return this.store.getAIHistory;
    },

    current_pdf() {
      return this.store.getCurrentPdf;
    },
  },
  
  methods: {
    formatDateAndTime(date) {
      return moment.unix(date).utcOffset(180).format("DD MMM YYYY, hh:mm A");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    reset() {
      this.reply = "";
      this.comment = "";
      this.resetValidation();
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    noRepliesFound() {
      this.alert.showInfo('No replies found');
    },

    addDocumentNotes() {
      this.validate().then((validator_response) => {
        this.valid = validator_response.valid;
        if (this.valid) {
          let documentIds = [];
          documentIds.push(this.item?.itemId);

          const formData = new FormData();
          formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
          formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
          formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
          formData.append("model", "getAIDocumentSummary");
          formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
          formData.append("question", this.comment);
          formData.append("moduleCode", this.moduleCode || this?.item?.moduleCode);
          formData.append("documentIds", documentIds);

          if (this.current_agenda && Object.keys(this.current_agenda).length > 0) {
            formData.append("documentType", 2);
          } else {
            if (!this.current_agenda_document || Object.keys(this.current_agenda_document).length === 0) {
              formData.append("documentType", 1);
            }
          }

          let folderId = null;

          if (this.item?.itemType == 1) {
            folderId = this.item?.itemId;
          }

          if (folderId) {
            formData.append("folderId", folderId);
          }

          this.store.setLoading(true);
          axios.post(UserData.getBaseUrl(), formData).then((response) => {
            this.$emit('add_note', this.item);
            this.alert.showSuccess(response.data.message);
            this.store.setLoading(false);
            this.reset();
          })
          .catch((e) => {
            console.log("Error", e);
            this.store.setLoading(false);
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.bubble {
  border-radius: 12px;
  padding: 12px 16px;
  max-width: 90%;
  word-break: break-word;
  display: inline-block;
}
.user-bubble {
  background: #e3f2fd;
  color: #1565c0;
  margin-bottom: 4px;
  margin-left: auto;
  text-align: right;
}
.ai-bubble {
  background: #ede7f6;
  color: #4527a0;
  margin-right: auto;
  text-align: left;
}
.meta {
  font-size: 0.85em;
  color: #888;
  margin-top: 4px;
}
</style>